import { useTranslation } from 'react-i18next';
import { useAdminImage } from '@/hooks/useAdminImage';

export default function AboutSection() {
  const { t } = useTranslation();

  const aboutImg = useAdminImage(
    'home',
    'images.home.about_img',
    'https://public.readdy.ai/ai/img_res/37d99c2b-77e8-4c73-bb19-5697c037374a.png'
  );

  return (
    <section id="about" className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs tracking-[0.15em] uppercase font-label">
              {t('about.tag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 mt-5 leading-[1.05]">
              {t('about.heading_line1')}
              <br />
              {t('about.heading_line2')}
            </h2>
            <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg font-body">
              {t('about.description')}
            </p>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-3xl bg-primary-800 p-8 md:p-10 overflow-hidden group">
              <div className="absolute top-4 left-4">
                <span className="text-xs text-primary-300/60 tracking-[0.15em] uppercase font-label">
                  {t('about.tag')}
                </span>
              </div>
              <div className="absolute top-4 right-6 flex gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-400/50"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-primary-400/50"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-primary-400/50"></span>
              </div>

              <div className="mt-8 md:mt-10">
                <i className="ri-double-quotes-l text-3xl text-primary-400/40"></i>
                <p className="mt-4 text-lg md:text-xl text-white/85 leading-relaxed font-body italic">
                  {t('about.quote')}
                </p>
              </div>

              <div className="mt-8 md:mt-10 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img
                      src={aboutImg}
                      alt={t('about.name')}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-white text-sm font-label font-semibold">{t('about.name')}</p>
                    <p className="text-primary-300/70 text-xs font-body mt-0.5">{t('about.position')}</p>
                  </div>
                </div>
                <a
                  href="#booking"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-white text-lg"></i>
                </a>
              </div>

              <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-primary-500/10 blur-3xl group-hover:bg-primary-500/20 transition-colors"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}